export const defaultImgDiameter = '40px';
